import { useEffect } from "react";
import { hasAppLoggedOutFlag, redirectToKeycloakLogin, signInViaSso } from "../../auth/logout";
import { AuthTransitionScreen } from "../../Components/AuthTransitionScreen";

export default function AppLoginPage() {
  useEffect(() => {
    if (hasAppLoggedOutFlag()) {
      void redirectToKeycloakLogin();
      return;
    }
    void signInViaSso();
  }, []);

  return <AuthTransitionScreen />;
}
